import React from 'react';

function Footer() {
  return (
    <footer className="min-footer sub-bg pt-30 pb-30" id="Footer">
      <div className="container">
        <div className="row">
          <div className="col-lg-4 col-md-6 md-mb15">
            <div className="logo icon-img-100">
              <img src="/dark/assets/imgs/sanbaylon_dark.png" alt="" style={{ width: '150px', height: 'auto' }}/>
            </div>
          </div>
          <div className="col-lg-4 order-md-3">
            <div className="text-center">
              <p className="fz-14">
                © 2025 San Baylon{' '}
                <span className="underline main-color">
                </span>
              </p>
            </div>
           </div>
           {/*
          <div className="col-lg-4 col-md-6 order-md-2 md-mb15">
            <div className="links d-flex justify-content-end">
              <ul className="rest d-flex align-items-center">
                <li className="ml-30">
                  <a href="/dark/page-contact3">Contattaci</a>
                </li>
              </ul>
            </div>
          </div>*/}
        </div>
      </div>
    </footer>
  );
}

export default Footer;
